import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import moment from 'moment';


import { isStreamLive } from 'store/models/Stream';

import { StatItem, StatItemList, StatItemMoney, StatItemNumber, StatItemPercent, StatItemHours } from 'components/Stats';
import GameCard, { GameCardLoading } from 'components/GameCard';
import { RightChevronIcon } from 'components/Svg';
import { EmptyItem } from 'components/EmptyItem';
import { LoadingStatItem } from 'components/Loading';
import ChannelCard from './ChannelCard';
import { ServiceTypes } from 'constants/constants';




// ====================
// ITEM
// ====================
export const GameItem = ({ game, stats, className, showGameCard = true, showName, showViewers = true, size, onClick, ...props }) => {
  return (
    <div key={game?._id} className={cx("g-game-item")}>
      { game && showGameCard &&
      <GameCard game={game} showName={showName} size="s" />}
      <StatItemList>
        <StatItemHours label="Length" value={stats?.gameTimeMinutes} />
        { showViewers && <>
        <StatItemNumber label="Avg. Viewers" value={stats?.streamAvgViewers} />
        <StatItemNumber label="Peak Viewers" value={stats?.streamMaxViewers} /></>}
        <StatItemMoney label="Media Value" value={stats?.totalMediaValue}/>
        <StatItemNumber label="Impressions" value={stats?.sceneViews} />
      </StatItemList>
    </div>
  );
}
export default GameItem;





// ====================
// LIST
// ====================
export const GameList = ({ games, stats, channels, loading, loadingCount = 4, showViewers = true, className, size, align, ...props }) => {
  if(!loading && _.isEmpty(games)) 
    return (
      <EmptyItem>
        <p>There were no games tagged during this time period</p>
      </EmptyItem>);

  return (
    <div className={cx("g-game-list", className, size, align)}>
      <div className="list-wrap">
        { loading && 
          _.map(_.fill(Array(loadingCount), '0'), (_, idx) => <LoadingStatItem key={idx} />) }

        { !loading && _.map(games, (game) => {
          return (
            <GameItem
              key={game?._id ?? 'none'}
              game={game}
              stats={stats?.[game?._id] ?? {}}
              size={size}
              showViewers={showViewers}
              {...props} />);
        })}
      </div>
    </div>)
}
  